import React, { Component, ComponentType } from "react";
import { connect } from "react-redux";

import { getPhotoWeb } from "./action";
import { MediaPhotoWebSetAction } from "./types";
import { PngPhoto } from "../../types/Media/PngPhoto";
import { RootState, MediaPhoto } from "../../types";

type StateProps = {
  data: PngPhoto[] | null;
};

type DispatchProps = {
  search: (
    refresh?: boolean,
    query?: string
  ) => Promise<MediaPhotoWebSetAction | { data: PngPhoto[] | null }>;
};

type Props = {
  // @TODO add typing when typing components
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Layout: ComponentType<any>;
  onSelect: (image: MediaPhoto) => void;
} & DispatchProps &
  StateProps;

type State = {
  error: null;
  loading: boolean;
  refreshing: boolean;
  query?: string;
};

class SearchImageWeb extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      refreshing: false,
    };
  }

  componentDidMount(): void {
    this.reFetch(true);
  }

  reFetch = (refresh: boolean, callback?: () => void): void => {
    const { search } = this.props;
    const { refreshing, loading, query } = this.state;
    if (refreshing || loading) {
      return;
    }

    this.setState({ refreshing: refresh, loading: !refresh }, async () => {
      try {
        await search(refresh, query);
        this.setState({ refreshing: false, loading: false, error: null });
        callback?.();
      } catch (error) {
        this.setState({ loading: false, refreshing: false, error: error });
      }
    });
  };

  onChangeText = (query: string): void => {
    this.setState({ query });
  };

  onSearch = (callback?: () => void): void => {
    const { search } = this.props;
    const { refreshing, loading, query } = this.state;
    if (refreshing || loading) {
      return;
    }

    this.setState({ loading: true }, async () => {
      try {
        await search(true, query);
        this.setState({ loading: false, refreshing: false, error: null });
        callback?.();
      } catch (error) {
        this.setState({ loading: false, refreshing: false, error: error });
      }
    });
  };

  render = (): JSX.Element => {
    const { Layout, data, onSelect } = this.props;
    const { loading, error, refreshing } = this.state;
    return (
      <Layout
        error={error}
        loading={loading}
        refreshing={refreshing}
        data={data}
        onSelect={onSelect}
        reFetch={this.reFetch}
        onSearch={this.onSearch}
        onChangeText={this.onChangeText}
      />
    );
  };
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    data: state.media.photoWeb,
  };
};

const mapDispatchToProps = {
  search: getPhotoWeb,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchImageWeb);
